import { type PimProductWithVariantsV1 } from '@redteclab/api/clients/bully'

export const productAccessorHasOffers = (
  product: PimProductWithVariantsV1,
): boolean =>
  product.variants.some((variant) => {
    return variant.offers?.length !== 0
  })
